import React from 'react';
import styled from 'styled-components';
import { CommonUtility } from 'utility';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Thumbnail = styled.img`
  width: ${({ size }) => size || 30}px;
  height: ${({ size }) => size || 30}px;
  border-radius: 2px;
  object-fit: cover;
`;

const Title = styled.span`
  margin-left: 8px;
`;

export const VideoWithTitle = ({ thumbnailUrl, title, size = 30, onClick }) => {
  return (
    <Wrapper onClick={onClick ? () => onClick() : undefined}>
      <Thumbnail src={thumbnailUrl} alt="video thumbnail" size={size} />
      <Title>{CommonUtility.truncateString(title, 30)}</Title>
    </Wrapper>
  );
};